import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'slid', namespaced: true })
export default class SLIDModule extends VuexModule {
  loadingSession = true;
  session = null;
  landingTracked:boolean = false;

  @Action
  async setSLIDSession(session) {
    this.context.commit('SET_SL_ID_SESSION', session);
  }

  @Mutation
  SET_SL_ID_SESSION(session) {
    this.session = session;
  }

  @Action
  async setLoadingSession(loading) {
    this.context.commit('SET_LOADING_SESSION', loading);
  }

  @Mutation
  SET_LOADING_SESSION(loading) {
    this.loadingSession = loading;
  }

  @Action
  async setLandingTracked(tracked) {
    this.context.commit('SET_LANDING_TRACKED', tracked);
  }

  @Mutation
  SET_LANDING_TRACKED(tracked) {
    this.landingTracked = tracked;
  }
}
